module.exports = __webpack_public_path__ + "static/img/yichu2.9605ad0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/yichu2.png
// module id = 6xer
// module chunks = 24